// extracted by mini-css-extract-plugin
export default {"container":"adc__container--RJSAb","countdown-container":"adc__countdown-container--y6T5x","flashing":"adc__flashing--xb5kv","counter-flash":"adc__counter-flash--sSVqJ"};